import {bootstrap}    from '@angular/platform-browser-dynamic';
import {AppComponent} from './app.component';
import {APP_ROUTER_PROVIDERS} from './app.routes';
import {Jsonp, JSONP_PROVIDERS, BrowserXhr}       from '@angular/http';
import {disableDeprecatedForms, provideForms, NgForm} from '@angular/forms';
import {enableProdMode} from '@angular/core';
import {HTTP_PROVIDERS, Http, XHRBackend, RequestOptions} from '@angular/http';
import {CustomHttp} from '../app/custom-http/custom.http';
import {ErrorNotifierService} from '../app/error-notifier/error.notifier';
import {CustomBrowserXhr} from '../app/customBrowserXhr/CustomBrowserXhr';
import {ProgressService} from '../app/customBrowserXhr/progress.service';
import {APP_BASE_HREF, LocationStrategy, HashLocationStrategy} from "@angular/common";

if (process.env.NODE_ENV == 'production') {
    enableProdMode();
}
enableProdMode();
bootstrap(AppComponent, [
    APP_ROUTER_PROVIDERS,
    ErrorNotifierService,
    ProgressService,
    HTTP_PROVIDERS,
    [{
        provide: Http,
        useFactory: (backend: XHRBackend, defaultOptions: RequestOptions, errorNotifier: ErrorNotifierService) => {
            return new CustomHttp(backend, defaultOptions, errorNotifier);
        },
        deps: [XHRBackend, RequestOptions, ErrorNotifierService]
    }],

    [{
        provide: BrowserXhr,
        useFactory: (progressService: ProgressService) => {
            return new CustomBrowserXhr(progressService)
        },
        deps: [ProgressService]
    }],

    JSONP_PROVIDERS, provideForms(), disableDeprecatedForms(), NgForm,
    [{provide: (APP_BASE_HREF, {useValue: "/"})}],
    [{provide: (LocationStrategy, {useClass: HashLocationStrategy})}]
])
    .catch(err => console.error(err));

//bootstrap(AppComponent);





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/main.ts